module.exports = __webpack_public_path__ + "assets/img/RewardBodyBtn0.dc50f315.png";